import { ConfigPedidoProps } from '../types';

import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { brlDecimal, brlPrice } from 'util/format';

export function usePedidoMinimo() {
    const { vlPedido, vlPesoLiquido, configPedido } = usePedidoCompraContext();
    const { vlPedidoMinimoLoja, tpControlePedidoMinimoLoja } = (configPedido || {}) as ConfigPedidoProps;
    const hasPedidoMinimo = typeof vlPedidoMinimoLoja === 'number';
    const hasMinimoSection = !!tpControlePedidoMinimoLoja && hasPedidoMinimo && vlPedidoMinimoLoja > 0;

    let vlParaPedidoMinimo = 0;
    let dsPedidoMinimo = '';
    let progressMinimo: number | undefined = undefined;

    if (hasMinimoSection) {
        const isPeso = tpControlePedidoMinimoLoja === 'PESO_TOTAL';
        const current = isPeso ? vlPesoLiquido : vlPedido;

        vlParaPedidoMinimo = Math.max(0, vlPedidoMinimoLoja - current);
        progressMinimo = (current / vlPedidoMinimoLoja) * 100;
        dsPedidoMinimo = isPeso ? `${brlDecimal(vlParaPedidoMinimo, 0, 3)} Kg` : brlPrice(vlParaPedidoMinimo);
    }

    return {
        dsPedidoMinimo,
        hasMinimoSection,
        progressMinimo,
        tpControlePedidoMinimoLoja,
        vlPesoLiquido,
        vlPedido,
        vlPedidoMinimoLoja,
    };
}
